import {UserProfile} from 'types/models/apps/Auth';
import {AuthUser} from '../models/AuthUser';

export const UPDATE_AUTH_USER = 'UPDATE_AUTH_USER';
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
export const SIGNOUT_AUTH_SUCCESS = 'SIGNOUT_AUTH_SUCCESS';
export const SET_LOGIN_SUCCESS = 'SET_LOGIN_SUCCESS';
export const GET_USER_PROFILE = 'GET_USER_PROFILE';

export interface SetAuthTokenActions {
  type: typeof SET_AUTH_TOKEN;
  payload: string | null;
}

export interface UpdateAuthUserActions {
  type: typeof UPDATE_AUTH_USER;
  payload: AuthUser | null;
}

export interface SignoutAuthUserActions {
  type: typeof SIGNOUT_AUTH_SUCCESS;
}

export interface SetLoginSuccessActions {
  type: typeof SET_LOGIN_SUCCESS;
}

export interface GetUserProfileAcions {
  type: typeof GET_USER_PROFILE;
  payload: UserProfile;
}

export type AuthActions =
  | UpdateAuthUserActions
  | SetAuthTokenActions
  | SetLoginSuccessActions
  | GetUserProfileAcions
  | SignoutAuthUserActions;
